import { PriceListById } from "../modules";

export const PriceListByIdPage = () => {
  return <PriceListById />;
};
